<!-- Page Title -->
<div class="row">
  @if (title) {
  <div class="col-12">
    @if (isSummary && isSubTitleEnabled && !isIMEdetailsSummary) {
    <h1 class="page-title-h1" tabindex="-1">
      {{ "SUMMARY_OF" | globalTranslate }}{{ title | globalTranslate }}
    </h1>
    } @if (isSummary && isSubTitleEnabled && isIMEdetailsSummary) {
    <h1 class="page-title-h1" tabindex="-1">
      Incurred Medical Expenses Summary
    </h1>
    } @if (!isSummary) {
    <h1 class="page-title-h1" tabindex="-1">{{ title | globalTranslate }}</h1>
    }
  </div>
  }
  <div class="col-4 d-flex justify-content-end align-items-center">
    @if (canPrint()) {
    <span class="fa-cta">
      <a (click)="print()" class="no-hover" tabindex="0">
        <span class="d-none d-md-inline-block float-end print"
          >&nbsp;{{ "PRINT" | globalTranslate }}</span
        >
        <i class="fa fa-fw fa-lg fa-print fa-border float-end"></i>
      </a>
    </span>
    }
  </div>
</div>